import axios from "../utils/axios";

export const getAllDepartments = async (page = 1, per_page = 15, filters = {}) => {
    const params = { ...filters };
    if (page) params.page = page;
    if (per_page) params.per_page = per_page;
    const { data } = await axios.get('/departments', { params });
    return data;
};

export const getDepartmentsForSelect = async () => {
    const { data } = await axios.get('/departments/for-select');
    return data;
};

export const getDepartment = async (id) => {
    const { data } = await axios.get(`/departments/${id}`);
    return data;
};

export const createDepartment = async (req) => {
    const { data } = await axios.post('/departments', req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const updateDepartment = async (req, id) => {
    const { data } = await axios.put(`/departments/${id}`, req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const deleteDepartment = async (id) => {
    const { data } = await axios.delete(`/departments/${id}`, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const deleteAllDepartments = async (req) => {
    const { data } = await axios.delete('/departments/mass-destroy', {
        data: req,
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const forceDeleteDepartment = async (id) => {
    const { data } = await axios.delete(`/departments/${id}/force-delete`, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const forceDeleteAllDepartments = async (ids) => {
    const { data } = await axios.delete('/departments/mass-force-delete', {
        data: ids,
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const restoreDepartment = async (id) => {
    const { data } = await axios.post(`/departments/${id}/restore`, {}, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const restoreAllDepartments = async (req) => {
    const { data } = await axios.post('/departments/mass-restore', req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};
